import { API_BASE } from "@/config/api";

export async function uploadMedia(file: File, altText = ""): Promise<{ url: string }> {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("alt_text", altText);
  const res = await fetch(`${API_BASE}/media`, { method: "POST", body: formData });
  const json = await res.json().catch(() => null);
  if (!res.ok) {
    if (res.status === 413) {
      throw new Error("La imagen pesa más de lo que acepta el servidor. Prueba con una más liviana (menos de 1 MB).");
    }
    throw new Error(json?.error || `No se pudo subir la imagen (el servidor respondió ${res.status}).`);
  }
  return json;
}
